import { DropdownMenu, TocItem } from "@gravity-ui/uikit";
import cn from "classnames";
import { useState } from "react";
import { useTranslate } from "src/i18n";

import { KnowledgeToc } from "../KnowledgeToc";
import styles from "./KnowledgeDropdownToc.module.scss";

interface KnowledgeDropdownTocProps {
  activeId: string | null;
  items: TocItem[];
  size?: "s" | "m" | "l" | "xl";
}

export const KnowledgeDropdownToc = ({
  items,
  activeId,
  size,
}: KnowledgeDropdownTocProps) => {
  const { t } = useTranslate();
  const [open, setOpen] = useState(false);
  return (
    <>
      <DropdownMenu
        open={open}
        onOpenToggle={setOpen}
        renderSwitcher={(props) => (
          <div {...props} className={styles.dropdownCustom}>
            <div
              className={cn(
                styles.dropdownText,
                size === "l" ? styles.dropdownTextBig : null,
              )}
            >
              {t("page_overview", "Обзор страницы")}
            </div>
          </div>
        )}
      >
        <div className={styles.headerDropdown}>
          <KnowledgeToc
            items={items}
            activeId={activeId}
            onClick={() => setOpen(false)}
          />
        </div>
      </DropdownMenu>
    </>
  );
};
